import { useEffect, useRef } from "react"
import mapboxgl from 'mapbox-gl'
import { createPortal } from "react-dom";

const Marker = ({ map, feature, isActive, onClick }) => {
    const { geometry,properties } = feature

    const markerRef = useRef()
    const contentRef = useRef(document.createElement("div"))

    useEffect(() => {
       // console.log( geometry);
        
        markerRef.current = new mapboxgl.Marker(contentRef.current)
            .setLngLat([geometry.coordinates[0], geometry.coordinates[1]])
            .addTo(map)

        return () => {
             markerRef.current.remove()
        }
    }, [feature])

    return (
        <>
            {createPortal(
                <img
                    onClick={() => onClick(feature)}
                    /* style={{
                        display: "inline-block",
                        padding: "2px 10px",
                        borderRadius: "50px",
                        backgroundColor: isActive ? "#333" : "#fff",
                        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.5)",
                        fontFamily: "Arial, sans-serif",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: isActive ? "#fff" : "#333",
                        textAlign: "center",
                    }} */
                   style={{width:"50px", height:"50px"}}
                   src={"./ic_obra.svg"}
                >
                    {/* properties?.mag ??null */ }
                </img>,
                contentRef.current
            )}
        </>
    )
}

export default Marker